import api from '@/api/client'

/** Read every page for screens that filter a complete list locally. */
export const fetchAllPages = async (url, params = {}) => {
  const items = []
  let page = 1
  for (; page <= 1000; page += 1) {
    const response = await api.get(url, { params: { ...params, page, page_size: 100 } })
    const data = response.data
    if (Array.isArray(data)) return data
    if (!Array.isArray(data?.results)) throw new Error('Invalid paginated response')
    items.push(...data.results)
    if (!data.next) return items
    if (!data.results.length) throw new Error('Pagination did not advance')
  }
  throw new Error('Too many pages to load. Narrow the filters and try again.')
}
